import CloseIcon from '@mui/icons-material/Close';
import {
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	IconButton,
	useTheme,
} from '@mui/material';
import { ReactNode } from 'react';

interface DeleteModalProps {
	open: boolean;
	onClose: () => void;
	title?: string;
	children: ReactNode;
	actions: ReactNode;
	className?: string;
}

export const DeleteModal = ({
	open,
	onClose,
	title,
	children,
	actions,
	className,
}: DeleteModalProps) => {
	const theme = useTheme();

	return (
		<Dialog
			open={open}
			onClose={onClose}
			fullWidth
			maxWidth="sm"
			classes={{ paper: className }}
			sx={{
				'& .MuiPaper-root': {
					borderRadius: '15px',
					boxShadow: '0px 2px 6px 0px #00000040',
					[theme.breakpoints.down('sm')]: {
						width: '390px',
					},
				},
			}}
		>
			<DialogTitle
				sx={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
					borderBottom: '1px solid #E0E0E0',
					padding: '20px 20px 12px 20px',
				}}
			>
				{title}
				<IconButton onClick={onClose}>
					<CloseIcon />
				</IconButton>
			</DialogTitle>
			<DialogContent
				sx={{
					marginTop: '20px',
					padding: '20px',
					display: 'flex',
					flexDirection: 'column',
					gap: '20px',
				}}
			>
				{children}
			</DialogContent>
			<DialogActions sx={{ borderTop: '1px solid #E0E0E0', padding: '20px' }}>
				{actions}
			</DialogActions>
		</Dialog>
	);
};
